export const NUXT_IMPORT_YAML = `project:
  name: recipe-nuxt
  tags:
    - zerops-recipe

services:
  - hostname: ssrapp
    type: nodejs@20
    zeropsSetup: app
    enableSubdomainAccess: true
    buildFromGit: https://github.com/zeropsio/recipe-nuxt-nodejs

  - hostname: staticapp
    type: static
    zeropsSetup: app
    enableSubdomainAccess: true
    buildFromGit: https://github.com/zeropsio/recipe-nuxt-static`;
